var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{attrs:{"type":"submit","disabled":_vm.form.busy,"aria-disabled":_vm.form.busy}},[(_vm.form.busy && _vm.spinner)?_c('span',{staticClass:"spinner-border spinner-border-sm",attrs:{"role":"status","aria-hidden":"true"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }